import React, { useEffect, useState } from 'react';
import styles from './NumberInput.module.css';

const NumberInput = ({
  value,
  mixed,
  min,
  max,
  step = 1,
  disabled,
  onCommit,
  suffix,
}) => {
  const [draft, setDraft] = useState('');

  useEffect(() => {
    if (mixed) {
      setDraft('');
    } else if (value !== undefined && value !== null) {
      setDraft(String(value));
    } else {
      setDraft('');
    }
  }, [mixed, value]);

  const handleCommit = () => {
    if (draft === '' || Number.isNaN(Number(draft))) {
      setDraft(mixed ? '' : String(value ?? ''));
      return;
    }
    const raw = Number(draft);
    const numeric = step < 1 ? Number(raw.toFixed(2)) : Math.round(raw);
    if (min !== undefined && numeric < min) return;
    if (max !== undefined && numeric > max) return;
    onCommit(numeric);
  };

  return (
    <div className={styles.wrapper}>
      <input
        className={styles.input}
        type="number"
        min={min}
        max={max}
        step={step}
        placeholder={mixed ? '--' : ''}
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={handleCommit}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            handleCommit();
          }
        }}
        disabled={disabled}
      />
      {suffix && <span className={styles.suffix}>{suffix}</span>}
    </div>
  );
};

export default NumberInput;
